import React, { useRef, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Paper, Typography } from '@material-ui/core';
import RMSCommonDialog from '../../shared/components/dialog/RMSCommonDialog';
import { RMSButton } from '../../shared/components/buttons';
import { RMSTextField, RMSSignaturePad } from '../../shared/components/form-controls';
import CreateFormResolver from '../../shared/utility/createFormResolver';
import { executeApiAction } from '../../shared/utility/apiHelper';
import { notify } from 'reducers/NotifierReducer';
import setupSignatureSchema from '../schema/setupSignatureSchema';
import { setupSignature } from '../services/userSignatureService';

const SetupSignatureDialog = ({ open, onClose, onSaved }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [signatureEmpty, setSignatureEmpty] = useState(true);
  const signatureRef = useRef(null);

  const methods = useForm({
    resolver: CreateFormResolver(setupSignatureSchema),
    mode: 'onSubmit',
    defaultValues: { pin: '' },
  });

  const handleClear = () => {
    signatureRef.current?.clear();
  };

  const handleSave = methods.handleSubmit(async (values) => {
    const signatureImage = signatureRef.current?.getSignature();
    if (!signatureImage) {
      return;
    }

    await executeApiAction({
      setLoading,
      dispatch,
      action: () => setupSignature({ signatureData: signatureImage, pin: values.pin }),
      onSuccess: () => {
        dispatch(notify('Signature saved successfully', 'success'));
        onSaved?.();
        onClose();
      },
    });
  });

  return (
    <RMSCommonDialog
      open={open}
      title="Set Up Signature & PIN"
      onClose={onClose}
      loading={loading}
      maxWidth="sm"
      fullWidth
      closeOnBackdropClick={false}
      saveButton={{ show: false }}
      cancelButton={{ show: false }}
      dialogClassName="setup-signature-dialog">
      <FormProvider {...methods}>
        <Typography className="setup-signature-instruction">
          Draw your signature and set a PIN (4-8 digits):
        </Typography>

        <RMSTextField name="pin" label="New PIN" type="password" autoComplete="off" />

        <Paper variant="outlined" className="signature-card">
          <div className="signature-card-header">
            <Typography className="signature-title">Collect Signature</Typography>
            <RMSButton label="Clear" variant="outlined" onClick={handleClear} />
          </div>

          <RMSSignaturePad ref={signatureRef} height={180} onChange={setSignatureEmpty} />

          <div className="signature-footer">
            <RMSButton label="Skip" variant="outlined" onClick={onClose} />
            <RMSButton
              label="Save Signature"
              color="primary"
              disabled={signatureEmpty}
              onClick={handleSave}
            />
          </div>
        </Paper>
      </FormProvider>
    </RMSCommonDialog>
  );
};

export default SetupSignatureDialog;
